import { getCookie } from '@nykaa/utils/cookies';
import widgetTypes from './constants/widgetTypes';
const IMAGE_URL = 'image_url';
const COLOR = 'color';
const DEV_MODE = 'DEV_MODE';
const DEV_MODE_STATUS = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
};
const SHARE_TITLE = 'NDN DevMode Debugging Data - FE WEB';
const getAppConfigData = (inventories) => inventories.find((x) => (x.widgetData && x.widgetData.widgetType === widgetTypes.APP_CONFIG));
export const getPageStyle = (inventories) => {
    const appConfigInventory = getAppConfigData(inventories);
    const style = {};
    if (!appConfigInventory) {
        return style;
    }
    const { widgetData } = appConfigInventory;
    if (widgetData && widgetData.params) {
        const { params } = widgetData;
        const { hpBkgType, hpBkgColor, hpBkgImageUrl } = params;
        if ((hpBkgType === IMAGE_URL) && hpBkgImageUrl) {
            if (hpBkgColor) {
                style['background-color'] = hpBkgColor || '';
            }
            style['background-image'] = `url(${hpBkgImageUrl})`;
        }
        else if ((hpBkgType === COLOR) && hpBkgColor) {
            style.background = hpBkgColor;
        }
    }
    return style;
};
export const isValidUrl = (url = '') => {
    if (url && (url.indexOf('?') !== 0)) {
        return true;
    }
    return false;
};
export const getDevModeStatus = (isServer) => {
    if (isServer)
        return false;
    let status = false;
    try {
        const devModeCookie = getCookie(DEV_MODE);
        status = !!(devModeCookie && devModeCookie !== '' && !!(devModeCookie === DEV_MODE_STATUS.ACTIVE));
    }
    catch (error) {
        status = false;
    }
    return status;
};
export const getDataTransformedInString = (dataDump) => {
    let processedString = '';
    try {
        processedString = JSON.stringify(dataDump);
    }
    catch (error) {
        processedString = '';
    }
    return processedString;
};
export const handleRightClickCallback = (devModeData) => {
    // share Obj required template for navigator.share
    const shareObj = {
        title: SHARE_TITLE,
        text: getDataTransformedInString({
            devModeData,
            browser: window.navigator.userAgent || '',
            timeStamp: new Date() || '',
        }),
        url: window.location.href || '',
    };
    // share Obj in string, required for clipboard copy and alert text
    const shareObjInString = getDataTransformedInString(shareObj);
    try {
        navigator.share(shareObj);
    }
    catch (error) {
        alert(shareObjInString);
    }
};
